import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  Container,
  Wrapper,
  Copy,
  Spin,
  Row,
  KeyboardView
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";

import {
  appRedirect,
  updateList,
  getLists,
  toggleActionSheet,
  setActiveList,
  updateListFilter,
  clearAllLeadFilters,
  numberWithCommas,
  renderPrice,
  setModal,
  toggleModal,
  editActiveList
} from "app/NativeActions";

import Body from "./Body";

class EditList extends PureComponent {
  constructor(props) {
    super(props);

    this.handleBack = this.handleBack.bind(this);
    this.saveList = this.saveList.bind(this);
  }

  componentDidMount() {
    if (!this.props.active_list) {
      if (this.props.device == "desktop") {
        this.props.getLists({
          token: this.props.token,
          load_type: "refresh_single_list",
          list_id: this.props.match.params.id
        });
      } else {
        this.handleBack();
      }
    } else {
      this.props.getLists({
        token: this.props.token,
        load_type: "single_list",
        list_id: this.props.active_list.id
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.active_list && prevProps.active_list) {
      if (this.props.active_list.id != prevProps.active_list.id) {
        this.props.getLists({
          token: this.props.token,
          load_type: "single_list",
          list_id: this.props.active_list.id
        });
      }
    }
  }

  handleBack() {
    this.props.setActiveList(null);
    this.props.appRedirect({
      redirect: "goBack",
      payload: { type: "list_builder" }
    });
  }

  checkIfNeedsToSave() {
    if (this.props.active_list && this.props.edit_active_list) {
      if (
        this.props.active_list.title !== this.props.edit_active_list.title ||
        parseInt(this.props.active_list.smart_list) !==
          parseInt(this.props.edit_active_list.smart_list) ||
        parseInt(this.props.active_list.start_marketing) !==
          parseInt(this.props.edit_active_list.start_marketing)
      ) {
        return true;
      }
    }

    return false;
  }

  renderSaveButton() {
    if (this.checkIfNeedsToSave()) {
      return (
        <Row style={{ justifyContent: "flex-end" }}>
          <PillButton primary={true} onPress={() => this.checkStartMarketing()}>
            Save List
          </PillButton>
        </Row>
      );
    }
  }
  saveList() {
    this.props.updateList({
      token: this.props.token,
      type: "update_list",
      smart_list: this.props.edit_active_list.smart_list,
      start_marketing:
        this.props.edit_active_list.smart_list == 0
          ? 0
          : this.props.edit_active_list.start_marketing
          ? this.props.edit_active_list.start_marketing
          : 0,
      title: this.props.edit_active_list.title,
      list_id: this.props.edit_active_list.id
    });
  }

  checkStartMarketing() {
    const { active_list, pricing } = this.props;
    const { start_marketing, smart_list } = this.props.edit_active_list;

    if (start_marketing == 1 && smart_list == 1 && active_list.lead_count > 1) {
      this.props.setModal({
        title:
          "Are you sure you want to start mailers/campaigns for " +
          numberWithCommas(active_list.lead_count) +
          " leads added from this list?",
        description:
          "By starting mailers/campaigns, you'll be starting the mailing sequence for all " +
          numberWithCommas(active_list.lead_count) +
          " leads added from this list. You'll be using " +
          renderPrice(pricing.mailer_price * active_list.lead_count) +
          " of your DealCredit. You will be charged for more credit if you don't have enough. You cannot undo this. Mailers will be sent to the queue within the hour.",
        icon: "",
        submit: "Save List",
        onPress: this.saveList,
        cancel: "Nevermind. Cancel Action.",
        onCancel: () => {}
      });
      this.props.toggleModal({ show: true, type: "normal" });
    } else {
      this.saveList();
    }
  }

  render() {
    if (this.props.refreshing_single_list_item) {
      return (
        <Container>
          <Header
            title={"Edit List"}
            leftButtonIcon="arrow-back"
            leftButtonAction={this.handleBack}
          />
          <Wrapper
            style={{
              padding: 20,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Row>
              <Spin size={"small"} />
              <Copy style={{ marginLeft: 10 }}>Loading List...</Copy>
            </Row>
          </Wrapper>
        </Container>
      );
    } else if (this.props.active_list) {
      return (
        <Container>
          <Header
            title={"Edit List"}
            leftButtonIcon="arrow-back"
            leftButtonAction={this.handleBack}
            rightButtonIcon={
              this.checkIfNeedsToSave()
                ? "check"
                : this.props.active_list.building == 1
                ? ""
                : "more-vert"
            }
            rightButtonAction={
              this.checkIfNeedsToSave()
                ? () => {
                    this.checkStartMarketing();
                  }
                : this.props.active_list.building == 1
                ? () => {}
                : () => {
                    this.props.toggleActionSheet("list_more");
                  }
            }
          />
          <KeyboardView>
            <Body
              {...this.props}
              editActiveList={this.props.editActiveList}
              edit_active_list={this.props.edit_active_list}
            />
            {this.renderSaveButton()}
          </KeyboardView>
        </Container>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, settings, list, billing }) => {
  const { token, user } = auth;
  const { device, isMobile, platform, isIphoneX } = native;
  const { colors } = settings;
  const { plan_modules, card_info, pricing } = billing;

  const {
    active_list,
    loading_single_list_item,
    refreshing_single_list_item,
    get_list_count,
    edit_active_list
  } = list;

  return {
    token,
    user,
    device,
    isMobile,
    platform,
    isIphoneX,
    colors,

    active_list,
    loading_single_list_item,
    refreshing_single_list_item,

    plan_modules,
    card_info,
    get_list_count,
    pricing,
    edit_active_list
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  updateList,
  getLists,
  toggleActionSheet,
  setActiveList,
  updateListFilter,
  clearAllLeadFilters,
  setModal,
  toggleModal,
  editActiveList
})(EditList);
